/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { NavLink } from "react-router-dom";

function FooterResources () {
    //TODO: SC-2340 - Fill out URLs when internal pages are ready
    return (
        <div className="footer-location footer-column">
            <h3 className='footer-column-title'>Helpful Resources</h3>
            <ul className="footer-column-content">
                <li>
                    <NavLink to="/">Report an Issue</NavLink>
                </li>
                <li>
                    <NavLink to="/">Get Involved: Public Engagement</NavLink>
                </li>
                <li>
                    <NavLink to="/">Careers</NavLink>
                </li>
                <li>
                    <NavLink to="/">Access to Information</NavLink>
                </li>
            </ul>
        </div>
    );
}

export { FooterResources };
